import React, { Component, createRef } from "react";
import { bindActionCreators } from "redux";
import { isLoggedIn, getLoggedInUser } from "../services/AuthenticationService";
import moment from "moment";
import { Row, Col } from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { formatNumber } from "../lib/helper";
import { IS_UNSAVED } from "../actions/constant";

import {
  InputText,
  Loading,
  Valert,
  Vmodal,
  Dropdown,
  NoDataAlert,
} from "../components";
import forumActions from "../actions/forumActions";
import { t } from "i18next/dist/commonjs";
import "./styles/forumMeModern.css";

const ForumItem = ({
  data,
  likedAct,
  pageMode,
  askDeleteCaller,
  selectForEdit,
  handlePostEdit,
  checkStatusForRedirect,
  t,
  message,
}) => {
  return (
    <div className="forumItem">
      <Row
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 5px 0 5px",
        }}
      >
        <div>
          {pageMode == "user" && (
            <div
              className="checkmarkContainer"
              onClick={() => selectForEdit(data._id, "multiple")}
              style={{ marginTop: "3px", marginLeft: "12px" }}
            >
              <input type="checkbox" checked={data.selected ? "checked" : ""} />
              <span className="checkmark" />
            </div>
          )}
          {pageMode == "user" ? (
            <div className="dateTime" style={{ display: "inline" }}>
              {data.date
                ? moment.unix(data.date).format("DD MMM YYYY, hh:mma")
                : moment(data.created_at).format("DD MMM YYYY, hh:mma")}
            </div>
          ) : (
            <div className="dateTime" style={{ display: "inline" }}>
              {data.draft_at && data.draft_at !== ""
                ? moment.unix(data.draft_at).format("DD MMM YYYY, hh:mma")
                : data.date
                  ? moment.unix(data.date).format("DD MMM YYYY, hh:mma")
                  : moment(data.created_at).format("DD MMM YYYY, hh:mma")}
            </div>
          )}
        </div>

        <div>
          {pageMode == "user" && (
            // <div className="relevant">
            //   {/* <Row>
            //   <Col>
            //     <i className="fa fa-envelope defIcon"></i>
            //   </Col>
            //   <Col>
            //     <i className="fa fa-undo-alt defIcon" />
            //   </Col>
            // </Row> */}
            // </div>
            <div style={{ marginRight: "24px" }}>
              <Row style={{ marginRight: "-2px", paddingTop: "3px" }}>
                <div
                  style={{
                    marginRight: "-1px",
                    marginTop: "-2px",
                    color: "#007bff",
                  }}
                  onClick={() => message(data)}
                >
                  <a href="/message">
                    <i
                      style={{
                        color: "#007bff",
                      }}
                      className="far fa-envelope"
                    ></i>
                  </a>
                </div>

                <div
                  className="relevant"
                  style={{ paddingRight: "5px", paddingTop: "0.6" }}
                >
                  {t("forum.RELAVENT_TEXT")}
                </div>
                <div
                  className="vote yesVote"
                  onClick={(e) => likedAct(data._id, true)}
                  style={{ width: "64px", marginTop: "0.2px" }}
                >
                  <i className="fa fa-check-circle" />
                  <div style={{ display: "inline", position: "relative" }}>
                    {formatNumber(data.relevant.up)}
                  </div>
                </div>
                <div
                  className="vote noVote"
                  onClick={(e) => likedAct(data._id, false)}
                  style={{ width: "43px", marginTop: "0.2px" }}
                >
                  <i className="fa fa-times-circle" />
                  <div style={{ display: "inline", position: "relative" }}>
                    {formatNumber(data.relevant.down)}
                  </div>
                </div>
              </Row>
            </div>
          )}
          {pageMode === "mine" && (
            <div className="relevant">
              <Row>
                <div onClick={() => handlePostEdit(data._id)}>
                  {data.selected ? (
                    <i
                      className="fa fa-pencil-alt defIconSelected"
                      style={{
                        paddingTop: "8px",
                      }}
                    ></i>
                  ) : (
                    <i
                      className="fa fa-pencil-alt defIcon"
                      style={{ paddingRight: "15px", paddingTop: "8px" }}
                    ></i>
                  )}
                </div>
                <div>
                  <i
                    className="far fa-trash-alt defIcon"
                    onClick={() => askDeleteCaller(data._id)}
                    style={{ paddingRight: "15px", paddingTop: "8px" }}
                  ></i>
                </div>
                <div
                  className="vote yesVote"
                  style={{
                    cursor: "default",
                    paddingTop: "5px",
                    width: "70px",
                  }}
                >
                  <i className="fa fa-check-circle" />
                  <div
                    style={{
                      fontWeight: "normal",
                      display: "inline",
                      position: "relative",
                    }}
                  >
                    {formatNumber(data.relevant.up)}/
                    {formatNumber(data.relevant.up + data.relevant.down)}
                  </div>
                </div>
              </Row>
            </div>
          )}
        </div>
      </Row>
      <p
        style={{
          // whiteSpace: "pre-wrap",
          marginLeft: pageMode === "user" ? "12px" : "",
          marginRight: pageMode === "user" ? "10px" : "",
        }}
      >
        <span style={{ color: "#ff0000" }}>
          {data && data.publish_status == "draft"
            ? t("forum.DRAFT_TEXT")
            : pageMode === "mine" && data.publish_status === "republishing"
              ? t("forum.REPUBLISHING_TEXT")
              : data.publish_status == "republished" ||
                data.publish_status_draft == "republished"
                ? t("forum.EDITED_TEXT")
                : ""}{" "}
        </span>
        <span style={{ whiteSpace: "pre-wrap" }}>
          {data.body}
        </span>
      </p>
      <div>
        {data.related &&
          data.related.map((item, key) => {
            return (
              <a
                key={key}
                className="relatedPosts"
                onClick={() => checkStatusForRedirect(item)}
                style={{
                  marginLeft: pageMode === "user" ? "12px" : "",
                  marginRight: pageMode === "user" ? "10px" : "",
                }}
              >
                {item}
              </a>
            );
          })}
      </div>
    </div>
  );
};

class ForumMe extends Component {
  constructor(props) {
    super(props);
    this.myRef = createRef();
    this.state = {
      textAreaPlaceHolder: t("general.SELECT_SYMPTOM_PLACEHOLDER"),
      loggedInUserID: "",
      inputtext: "",
      redirectLink: "",
      deleteId: "",
      symptomSelect: false,
    };
    this.askDeleteCaller = this.askDeleteCaller.bind(this);
    this.handlePostEdit = this.handlePostEdit.bind(this);
    this.checkStatusForRedirect = this.checkStatusForRedirect.bind(this);
    this.redirectLink = "";
    this.deleteId = "";
  }
  async componentDidMount() {
    if (!isLoggedIn()) {
      this.props.history.push("/");
      return;
    }
    let linksToNewPostItems = await sessionStorage.getItem(
      "linksToNewPostItems"
    );
    let linksToNewPostSymptom = await sessionStorage.getItem(
      "linksToNewPostSymptom"
    );
    this.linksToNewPostItems =
      linksToNewPostItems && linksToNewPostItems.split(",");
    window.linksToNewPostItems = undefined;
    this.linksToNewPostSymptom = window.linksToNewPostSymptom;
    window.linksToNewPostSymptom = undefined;
    this.loggedInUser = getLoggedInUser();
    this.pageMode = "mine";
    if (this.props.match.params.userId) {
      if (this.loggedInUser._id != this.props.match.params.userId) {
        this.loggedInUser._id = this.props.match.params.userId;
        this.pageMode = "user";
      }
    }
    this.setState({ loggedInUserID: this.loggedInUser._id });

    // “mine” needs both => "", “user” sees only non-draft => 0
    let showDraft = this.pageMode === "user" ? 0 : "";

    // let showDraft = "";
    // if (this.pageMode === "user") {
    //   showDraft = 0;
    // }
    await this.props.forumMeInitialization(
      this.loggedInUser._id,
      showDraft,
      this.pageMode,
      ""
    );
    if (linksToNewPostSymptom && linksToNewPostSymptom !== "undefined") {
      // this.catValue = this.linksToNewPostSymptom;
      const hasSymptom =
        this.props.symptomsList &&
        this.props.symptomsList.some(
          (symptom) => symptom.value == linksToNewPostSymptom
        );
      this.props.onChangeFilters(
        {
          name: "symptom",
          value: hasSymptom ? linksToNewPostSymptom : "blank",
        },
        this.props.forumFiltersForm,
        this.loggedInUser._id,
        this.pageMode === "user" ? 0 : "",
        this.pageMode,
        "forumMe"
      );
    }
    this.inputPlaceHolderMaker = this.inputPlaceHolderMaker.bind(this);
    sessionStorage.clear();
  }
  leave = (location) => {
    if (this.props.forumFiltersForm.body && this.props.forumFiltersForm.symptom)
      return this.props.t("general.UNSAVED_LEAVE_PAGE_TEXT");
  };
  inputPlaceHolderMaker() {
    let result = this.props.t("forum.CREATE_POST_TEXTAREA_TEXT");
    if (
      this.props.forumFiltersForm.symptom &&
      (this.props.forumFiltersForm.symptom != "null" ||
        this.props.forumFiltersForm.symptom != "blank")
    ) {
      // let result = "";
      if (this.props.symptomsList) {
        this.props.symptomsList.forEach((element) => {
          if (element.value == this.props.forumFiltersForm.symptom) {
            if (
              this.loggedInUser &&
              this.loggedInUser.lang &&
              this.loggedInUser.lang === "1200000000001000015"
            ) {
              result = `在此处输入您${element.label}的经验。`;
            } else if (
              this.loggedInUser &&
              this.loggedInUser.lang &&
              this.loggedInUser.lang === "1200000000001000016"
            ) {
              result = `在此處輸入您${element.label}的經驗。`;
            } else {
              result = `Enter your experience about ${element.label} here.`;
            }
          }
        });
      }
    }
    return result;
  }
  async askDeleteCaller(id) {
    this.deleteId = await id;
    this.setState({ deleteId: id });
    this.deleteValert.changeStatus();
  }
  cancelPost() {
    if (this.props.forumFiltersForm._id) {
      this.props.selectForEdit(this.props.forumFiltersForm._id);
      localStorage.removeItem("unsavedAlertData");
    } else {
      localStorage.removeItem("unsavedAlertData");
      this.props.cancelPost();
    }
  }
  message(data) {
    localStorage.setItem("post", JSON.stringify(data));
  }

  symptomSelected(e) {
    const { changeSymptomWithoutSavePost, changeSymptomWithoutSaveDraftPost } =
      this.props;
    this.catValue = e
      ? { name: e.target.name, value: e.target.value }
      : this.catValue;
    if (
      !this.props.editMode &&
      this.props.forumFiltersForm.symptom != "null" &&
      this.props.forumFiltersForm.body != ""
    ) {
      this.unifinishedNewSymptom.changeStatus();
    } else {
      if (IS_UNSAVED() == "yes") {
        this.setState({ symptomSelect: true });
        this.dataLost.changeStatus();
      } else {
        this.props.onChangeFilters(
          this.catValue,
          this.props.forumFiltersForm,
          this.loggedInUser._id,
          this.pageMode === "user" ? 0 : "",
          this.pageMode,
          "forumMe"
        );
        this.scrollToTop();
      }
    }
  }
  symptomPosclicked() {
    this.props.onChangeFilters(
      this.catValue,
      this.props.forumFiltersForm,
      this.loggedInUser._id,
      this.pageMode === "user" ? 0 : "",
      this.pageMode,
      "forumMe"
    );
  }

  handlePostEdit(id) {
    this.redirectLink = "";
    this.setState({ symptomSelect: false });
    if (
      this.props.forumFiltersForm.selectedItem > -1 &&
      this.props.editMode &&
      this.props.forumFiltersForm.body !== this.props.selectedPost.body
    ) {
      this.dataLost.changeStatus();
    } else if (
      !this.props.editMode &&
      this.props.forumFiltersForm.symptom != "null" &&
      this.props.forumFiltersForm.body != ""
    ) {
      this.unfinishedNewPost.changeStatus();
    } else {
      this.props.selectForEdit(id);
    }
    this.postId = id;
  }

  async checkStatusForRedirect(item) {
    // this.redirectLink = item;
    // await this.props.forumSinglInitialization(this.redirectLink);

    // Derive the postId and the full URL separately
    const postId = (item && item.startsWith("/forum/post/"))
      ? item.split("/").pop()
      : item;
    this.redirectLink = `/forum/post/${postId}`;

    // forumSinglInitialization expects a postId, not a full path
    await this.props.forumSinglInitialization(postId);

    if (this.props.singlePostItem) {
      const { publish_status } = this.props.singlePostItem;
      if (publish_status === "irelevant") {
        this.irrelevantPost.changeStatus();
      } else if (
        this.props.forumFiltersForm.selectedItem > -1 &&
        this.props.editMode &&
        this.props.forumFiltersForm.body !== this.props.selectedPost.body
      ) {
        // this.redirectLink = item;
        this.unfinishedReplyRedirect.changeStatus();
        IS_UNSAVED("yes");
      } else if (
        !this.props.editMode &&
        this.props.forumFiltersForm.symptom != "null" &&
        this.props.forumFiltersForm.body != ""
      ) {
        // this.redirectLink = item;
        this.unfinishedNewPostRedirect.changeStatus();
        IS_UNSAVED("yes");
      } else {
        // window.location.href = `/forum/post/${this.redirectLink}`;
        window.location.href = this.redirectLink;
      }
    }
  }

  async redirectToLink() {
    // If redirectLink is a forum post, keep the existing post-safety logic
    if (this.redirectLink && this.redirectLink.startsWith('/forum/post/')) {
      const postId = this.redirectLink.split('/').pop();
      await this.props.forumSinglInitialization(postId);
      if (this.props.singlePostItem) {
        const { publish_status } = this.props.singlePostItem;
        if (publish_status === "irelevant") {
          this.irrelevantPost.changeStatus();
        } else {
          window.location.href = this.redirectLink;
        }
      }
      return;
    }

    // Otherwise, go straight to the URL (e.g., /infoandsupport)
    if (this.redirectLink) {
      localStorage.removeItem("unsavedAlertData");
      IS_UNSAVED("no");
      window.location.href = this.redirectLink;
    }
  }

  posClicked() {
    this.props.selectForEdit(this.postId);
    if (this.state.symptomSelect) {
      this.props.onChangeFilters(
        this.catValue,
        this.props.forumFiltersForm,
        this.loggedInUser._id,
        this.pageMode === "user" ? 0 : "",
        this.pageMode,
        "forumMe"
      );
    }
  }
  fetchMoreData = () => {
    // let showDraft = "";
    // if (this.pageMode == "user") {
    //   showDraft = 0;
    // }

    // “mine” => both (""), “user” => 0
    let showDraft = this.pageMode === "user" ? 0 : "";

    let nextPage = this.props.postsList.current_page + 1;
    this.props.forumLoadMore(
      this.props.forumFiltersForm.symptom,
      false,
      false,
      this.state.loggedInUserID,
      showDraft,
      false,
      nextPage
    );
  };
  scrollToTop() {
    this.myRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }

  handleBlockedInfoClick = (e) => {
    e.preventDefault();
    this.redirectLink = "/infoandsupport";

    const { editMode, forumFiltersForm, selectedPost } = this.props;

    // Case A: Editing an existing post and there are unsaved changes
    if (editMode && forumFiltersForm.body !== (selectedPost && selectedPost.body)) {
      this.unfinishedReplyRedirect.changeStatus(); // shows Unsaved Edited Post modal
      return;
    }

    // Case B: Creating a new post and there's content (Save Draft would be enabled)
    if (!editMode && forumFiltersForm.body && forumFiltersForm.body.trim() !== "") {
      this.unfinishedNewPostRedirect.changeStatus(); // shows Unsaved New Post modal
      return;
    }

    // Otherwise navigate immediately
    window.location.href = this.redirectLink;
  };

  render() {
    const {
      t,
      postsList,
      symptomsList,
      onChangeFilters,
      forumFiltersForm,
      saveSuccess,
      isLoading,
      selectForEdit,
      editMode,
      likedAct,
      disabled,
      doArchive,
      relevantFailed,
      changeReduxState,
      singlePostItem,
    } = this.props;
    // if (saveSuccess && this.loggedInUser) {
    //   reGetPosts(forumFiltersForm, this.loggedInUser._id);
    // }
    var inputPlaceHolderMaker = this.inputPlaceHolderMaker();
    let userId = this.loggedInUser ? this.loggedInUser._id : "";
    let title = t("forum.MY_POSTS_TEXT") + `(ID: ${userId})`;
    if (this.pageMode == "user") {
      title = `ID: ${userId}` + t("forum.AUTHOR_POST_TEXT");
    }
    var inputDisabled = true;
    if (editMode) {
      inputDisabled = false;
    } else {
      inputDisabled =
        !forumFiltersForm.symptom ||
        this.props.forumFiltersForm.symptom == "null" ||
        this.props.forumFiltersForm.symptom == "blank";
    }
    let selectedItems = [];
    let archivedItems = [];
    if (postsList.data) {
      selectedItems = postsList.data.filter((item) => {
        return item.selected;
      });
      archivedItems = selectedItems;
      selectedItems = selectedItems.map((item) => item._id);
    }
    return (
      <div className="vPage mealPlannerPage flex forum-me-modern">
        <Loading isLoading={isLoading} />
        <Valert
          display={false}
          title={t("forum.NEW_POST_NOT_SAVED_TITLE")}
          question={t("forum.NEW_POST_NOT_SAVED_EDIT_TEXT")}
          onRef={(ref) => (this.unfinishedNewPost = ref)}
          positiveAction={() => {
            if (this.redirectLink !== "") {
              this.redirectToLink();
            } else {
              this.posClicked();
            }
          }}
        />
        <Valert
          display={false}
          title={t("forum.UNSAVED_NEW_POST_TITLE")}
          question={t("forum.UNSAVED_NEW_POST_TEXT_2")}
          onRef={(ref) => (this.unfinishedNewPostRedirect = ref)}
          positiveAction={() => {
            this.redirectToLink();
          }}
        />
        <Valert
          display={false}
          title={
            this.props.selectedPost && this.props.selectedPost.draft
              ? t("forum.DRAFT_NOT_SAVED_TITLE")
              : t("forum.POST_NOT_SAVED_TITLE")
          }
          question={
            this.props.selectedPost && this.props.selectedPost.draft
              ? t("forum.DRAFT_NOT_SAVED_TEXT")
              : t("forum.POST_NOT_SAVED_TEXT")
          }
          onRef={(ref) => (this.unfinishedReply = ref)}
          positiveAction={() => {
            if (this.redirectLink !== "") {
              this.redirectToLink();
            } else {
              this.posClicked();
            }
          }}
        />
        <Valert
          display={false}
          title={
            this.props.selectedPost && this.props.selectedPost.draft
              ? t("forum.UNSAVED_EDIT_DRAFT_TITLE")
              : t("forum.UNSAVED_EDIT_POST_TITLE")
          }
          question={
            this.props.selectedPost && this.props.selectedPost.draft
              ? t("forum.UNSAVED_EDIT_DRAFT_TEXT_2")
              : t("forum.UNSAVED_EDIT_POST_TEXT_2")
          }
          onRef={(ref) => (this.unfinishedReplyRedirect = ref)}
          positiveAction={() => {
            if (this.redirectLink !== "") {
              this.redirectToLink();
            } else {
              this.posClicked();
            }
          }}
        />
        <Valert
          display={false}
          title={t("forum.IRRELEVANT_POST_DELETED_TITLE")}
          question={t("forum.IRRELEVANT_POST_DELETED_TEXT")}
          onRef={(ref) => (this.irrelevantPost = ref)}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            return true;
          }}
          readOnly={true}
        />
        <Valert
          display={relevantFailed}
          title={t("forum.RELEVANT_FAILED_TITLE")}
          question={t("forum.RELEVANT_FAILED_MESSAGE")}
          positiveAction={() => {
            setTimeout(() => {
              changeReduxState("relevantFailed", false);
            }, 200);
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          title={
            this.props.forumFiltersForm.body && !editMode
              ? t("forum.NEW_POST_NOT_SAVED_TITLE")
              : this.props.forumFiltersForm._id === this.deleteId
                ? t("forum.DELETE_POST_CONFIRMATION_TITLE")
                : editMode &&
                  !forumFiltersForm.draft &&
                  this.props.forumFiltersForm.body !=
                  this.props.selectedPost.body
                  ? t("forum.POST_NOT_SAVED_TITLE")
                  : editMode &&
                    forumFiltersForm.draft &&
                    this.props.forumFiltersForm.body !=
                    this.props.selectedPost.body &&
                    this.props.forumFiltersForm._id != this.deleteId
                    ? t("forum.DRAFT_NOT_SAVED_TITLE")
                    : t("forum.DELETE_POST_CONFIRMATION_TITLE")
          }
          question={
            this.props.forumFiltersForm.body && !editMode
              ? t("forum.NEW_POST_NOT_SAVED_TEXT")
              : this.props.forumFiltersForm._id === this.state.deleteId
                ? t("forum.DELETE_POST_CONFIRMATION_TEXT")
                : editMode &&
                  !forumFiltersForm.draft &&
                  this.props.forumFiltersForm.body !=
                  this.props.selectedPost.body
                  ? t("forum.EDIT_POST_NOT_SAVED_DELETE_TEXT")
                  : editMode &&
                    forumFiltersForm.draft &&
                    this.props.forumFiltersForm.body !=
                    this.props.selectedPost.body
                    ? t("forum.DRAFT_NOT_SAVED_DELETE_TEXT")
                    : t("forum.DELETE_POST_CONFIRMATION_TEXT")
          }
          onRef={(ref) => (this.deleteValert = ref)}
          positiveAction={() => {
            this.props.deleteItem(this.deleteId);
            this.setState({ deleteId: "" });
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("forum.NEW_POST_NOT_SAVED_TITLE")}
          question={t("forum.NEW_POST_NOT_SAVED_EDIT_TEXT")}
          onRef={(ref) => (this.unifinishedNewSymptom = ref)}
          positiveAction={() => {
            this.symptomPosclicked(), this.scrollToTop();
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            this.props.forumFiltersForm.draft
              ? t("forum.DRAFT_NOT_SAVED_TITLE")
              : t("forum.POST_NOT_SAVED_TITLE")
          }
          question={
            this.props.forumFiltersForm.draft
              ? t("forum.DRAFT_NOT_SAVED_TEXT")
              : t("forum.POST_NOT_SAVED_TEXT")
          }
          onRef={(ref) => (this.dataLost = ref)}
          positiveAction={() => {
            this.posClicked();
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
          negativeAcction={() => {
            this.setState({ symptomSelect: false });
            this.dataLost.changeStatus();
          }}
        />
        <Vmodal
          displayStatus={this.props.draftModal}
          data={
            this.props.updateDraftModel ? (
              <div
                style={{
                  marginLeft: "15px",
                  marginRight: "15px",
                }}
              >
                <h4>{t("forum.UPDATE_DRAFT_TITLE")}</h4>
                <p>{t("forum.UPDATE_DRAFT_TEXT")}</p>
              </div>
            ) : (
              <div
                style={{
                  marginLeft: "15px",
                  marginRight: "15px",
                }}
              >
                <h4>{t("forum.SAVE_DRAFT_TITLE")}</h4>
                <p>{t("forum.SAVE_DRAFT_TEXT")}</p>
              </div>
            )
          }
          closeFunc={async () => {
            await this.props.forumMeInitialization(
              this.loggedInUser._id,
              this.pageMode === "user" ? 0 : "",
              this.pageMode,
              this.props.forumFiltersForm.symptom
            );
            this.scrollToTop();
            localStorage.removeItem("unsavedAlertData");
          }}
          timedClose={1000}
        />
        <Vmodal
          displayStatus={this.props.publishModal}
          data={
            <div>
              <h4>{t("forum.PUBLISHED_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("forum.PUBLISHED_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={async () => {
            this.props.clearForum();
            await this.props.forumMeInitialization(
              this.loggedInUser._id,
              this.pageMode === "user" ? 0 : "",
              this.pageMode,
              this.props.forumFiltersForm.symptom
            );
            this.scrollToTop();
            localStorage.removeItem("unsavedAlertData");
          }}
          timedClose={1000}
        />
        <Vmodal
          displayStatus={saveSuccess}
          data={
            <div>
              <h4>{t("forum.ARCHIVED_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("forum.ARCHIVED_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.clearForum();
            window.location.href = `/forum/archive`;
          }}
          timedClose={2000}
        />
        <Row>
          <Col className="myForumTitle" sm="8">
            <h3 style={{ marginLeft: "20px" }}>{title}</h3>
          </Col>
          <Col sm="4">
            <Dropdown
              name="symptom"
              options={[
                {
                  value: "blank",
                  label: this.props.t("forum.SYMPTOMS_LIST_LABEL"),
                },
                { value: "", label: this.props.t("forum.ALL_PLACEHOLDER") },
                ...symptomsList,
              ]}
              meta={{}}
              input={{
                
                onChange: (e) => {
                  this.symptomSelected(e);
                },
                name: "symptom",
                value: forumFiltersForm.symptom,
              }}
            />
          </Col>
        </Row>
        <div
          id="scrollableDiv"
          className="grayList forumGrid"
          style={{ flex: "1 1 0" }}
          ref={this.myRef}
        >
          {postsList.data && postsList.data.length > 0 ? (
            <InfiniteScroll
              dataLength={postsList.data.length}
              next={this.fetchMoreData}
              hasMore={postsList.next_page_url}
              loader={
                <h4
                  style={{
                    fontFamily: "Calibri, sans-serif",
                    fontSize: "14px",
                    color: "#007bff",
                    marginLeft: "44%",
                  }}
                >
                  <b className="loading">{t("forum.LOADING_TEXT")}</b>
                </h4>
              }
              scrollableTarget="scrollableDiv"
              endMessage={
                postsList.data.length > 0 ? (
                  <p
                    style={{
                      fontFamily: "Calibri, sans-serif",
                      textAlign: "center",
                      fontSize: "14px",
                      color: "#007bff",
                    }}
                  >
                    <b>{t("forum.END_OF_LIST_TEXT")}</b>
                  </p>
                ) : null
              }
            >
              {postsList.data.map((item, index) => {
                return this.pageMode === "mine" ? (
                  <ForumItem
                    data={item}
                    key={index}
                    editMode={editMode}
                    pageMode={this.pageMode}
                    askDeleteCaller={this.askDeleteCaller}
                    selectForEdit={selectForEdit}
                    handlePostEdit={this.handlePostEdit}
                    checkStatusForRedirect={this.checkStatusForRedirect}
                    likedAct={likedAct}
                    t={this.props.t}
                    message={this.message}
                    loggedInUserID={this.state.loggedInUserID}
                  />
                ) : (
                  (!item.draft ||
                    (item.draft && item.publish_status === "republishing")) &&
                  item.publish_status != "irelevant" && (
                    <ForumItem
                      data={item}
                      key={index}
                      editMode={editMode}
                      pageMode={this.pageMode}
                      askDeleteCaller={this.askDeleteCaller}
                      selectForEdit={selectForEdit}
                      handlePostEdit={this.handlePostEdit}
                      checkStatusForRedirect={this.checkStatusForRedirect}
                      likedAct={likedAct}
                      t={this.props.t}
                      message={this.message}
                      loggedInUserID={this.state.loggedInUserID}
                    />
                  )
                );
              })}
            </InfiniteScroll>
          ) : isLoading ? (
            ""
          ) : this.pageMode && this.pageMode === "user" ? (
            <NoDataAlert
              pl={35}
              pt={15}
              color="#656565"
              text={t("recipe.NO_SELECTED_AUTHOR_DATA_TEXT")}
              bg="rgb(249, 250, 251)"
            />
          ) : this.catValue === undefined ||
            !this.catValue.value ||
            this.catValue.value == "null" ||
            this.catValue.value == null ||
            this.catValue.value == "blank" ? (
            <NoDataAlert
              pl={30}
              pt={10}
              color="#656565"
              text={t("recipe.NO_CREATED_POST_DATA_TEXT")}
              bg="rgb(249, 250, 251)"
            />
          ) : (
            <NoDataAlert
              color="#656565"
              pl={30}
              pt={10}
              text={t("recipe.NO_CREATED_POST_DATA_FOR_SELECTED_CAT_TEXT")}
              bg="rgb(249, 250, 251)"
            />
          )}
        </div>
        {this.pageMode == "mine" && (
          <Row className="form-group">
            <Col>
              <InputText
                type="textarea"
                ref={(input) =>
                  input &&
                  (input.input.selectionStart = input.input.selectionEnd =
                    this.cursor)
                }
                placeholder={inputPlaceHolderMaker}
                disabled={inputDisabled}
                value={forumFiltersForm.body}
                input={{
                  onChange: (e) =>
                    onChangeFilters(e, "", "", "", this.pageMode, "forumMe"),
                  name: "body",
                  value: forumFiltersForm.body,
                }}
                meta={{}}
                style={{
                  height: "9rem",
                }}
                maxLength={5000}
              />
            </Col>
          </Row>
        )}
        {this.pageMode === "mine" && this.loggedInUser.is_block && (
          <Row className="form-group">
            <Col>
              <p className="blocked_user_text">
                {t("forum.IRRELEVANT_POST_USER_BLOCKED")}
                {this.loggedInUser &&
                  this.loggedInUser.lang &&
                  this.loggedInUser.lang === "1200000000001000015" && (
                    <span>
                      如有疑问，请
                      <a 
                        className="click_here"
                        href="/infoandsupport"
                        onClick={this.handleBlockedInfoClick}
                      >
                        点击此处
                      </a>
                      。
                    </span>
                  )}
                {this.loggedInUser &&
                  this.loggedInUser.lang &&
                  this.loggedInUser.lang === "1200000000001000016" && (
                    <span>
                      如有疑問，請
                      <a 
                        href="/infoandsupport"
                        className="click_here"
                        onClick={this.handleBlockedInfoClick}
                      >
                        點擊此處
                      </a>
                      。
                    </span>
                  )}
                {this.loggedInUser &&
                  this.loggedInUser.lang &&
                  this.loggedInUser.lang === "1200000000001000022" && (
                    <span>
                      <a 
                        href="/infoandsupport"
                        className="click_here"
                        onClick={this.handleBlockedInfoClick}
                      >
                        {" "}
                        Click here
                      </a>{" "}
                      if you have questions.
                    </span>
                  )}
              </p>
            </Col>
          </Row>
        )}
        <Row>
          {this.pageMode == "mine" && (
            <Col>
              <button
                className="btn btn-primary btnWide"
                onClick={() => {
                  editMode
                    ? this.props.EditForum(forumFiltersForm, true)
                    : this.props.insertForum(
                      forumFiltersForm,
                      this.linksToNewPostItems,
                      true
                    ),
                    localStorage.setItem(
                      "forumSymptom",
                      forumFiltersForm.symptom
                    );
                }}
                disabled={
                  (editMode &&
                    forumFiltersForm.body === this.props.selectedPost.body) ||
                    !forumFiltersForm.body
                    ? "disabled"
                    : ""
                }
              >
                {forumFiltersForm.draft
                  ? t("forum.EDIT_DRAFT_BUTTON")
                  : t("forum.SAVE_DRAFT_BUTTON")}
              </button>
            </Col>
          )}
          <Col>
            <button
              className="btn btn-primary btnWide"
              onClick={() =>
                editMode ||
                  (forumFiltersForm.body && forumFiltersForm.body.length > 0)
                  ? this.cancelPost()
                  : (window.location.href = "/forum")
              }
            >
              {/* {this.props.t("forum.MY_POSTS_TITLE")} */}
              {editMode ||
                (forumFiltersForm.body && forumFiltersForm.body.length > 0)
                ? t("general.CANCEL")
                : t("forum.PAGE_TITLE")}
            </button>
          </Col>

          {this.pageMode == "user" && (
            <Col>
              <button
                className="btn btn-primary btnWide"
                disabled={selectedItems.length <= 0}
                onClick={() => {
                  doArchive(archivedItems);
                }}
              >
                {t("forum.ARCHIVE_TITLE")}
              </button>
            </Col>
          )}
          {this.pageMode == "mine" && (
            <Col>
              <button
                className="btn btn-primary btnWide"
                disabled={this.loggedInUser.is_block ? true : disabled.publishButton}
                onClick={() => {
                  editMode
                    ? this.props.EditForum(forumFiltersForm, false)
                    : this.props.insertForum(
                      forumFiltersForm,
                      this.linksToNewPostItems,
                      false
                    ),
                    localStorage.setItem(
                      "forumSymptom",
                      forumFiltersForm.symptom
                    );
                }}
              >
                {/* {this.props.t("forum.ARCHIVE_TITLE")} */}
                <span>{t("forum.PUBLISH_BUTTON")}</span>
              </button>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}
//#region exports

const mapStateToProps = (state) => ({
  ...state.forumReducer,
});
ForumMe = translate("translations")(ForumMe);

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...forumActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ForumMe);



// WEBPACK FOOTER //
// ./src/pages/ForumMe.js